import { Component } from "react";
import CalendarDatePicker from "./calendar-date-picker";
import PropTypes from "prop-types";
import classNames from "classnames";
import { IconButton } from "@evertrue/et-components";
import moment from "moment";
import CalendarClock from "components/calendar/calendar-clock";

const CaptionComp = ({ date, monthYearChanged }) => {
  const caption_date_string = moment(date).format("MMM YYYY");
  const onPreviousClick = () => {
    const new_date = moment(date)
      .subtract(1, "M")
      .startOf("Month");
    monthYearChanged(new_date);
  };
  const onNextClick = () => {
    const new_date = moment(date)
      .add(1, "M")
      .startOf("Month");
    monthYearChanged(new_date);
  };
  return (
    <div className="DayPicker-Caption">
      <IconButton title="previous month" icon="chevron-left" onClick={onPreviousClick} />
      <div className="DayPicker-Caption-text">{caption_date_string}</div>
      <IconButton title="next month" icon="chevron-right" onClick={onNextClick} />
    </div>
  );
};
CaptionComp.propTypes = {
  date: PropTypes.object,
  monthYearChanged: PropTypes.func,
};
CaptionComp.defaultProps = {
  date: {},
  monthYearChanged: () => {},
};

class DateTimePicker extends Component {
  static propTypes = {
    handleDayClick: PropTypes.func,
    topComponent: PropTypes.element,
    bottomComponent: PropTypes.element,
    selectedDate: PropTypes.number,
    extraClass: PropTypes.string,
    clockEnabled: PropTypes.bool,
  };

  static defaultProps = {
    handleDayClick: () => {},
    selectedDate: 0,
    extraClass: "",
    clockEnabled: false,
  };

  state = {
    selected_time: 43200000,
    month: moment(),
  };

  componentDidMount() {
    if (this.props.selectedDate) {
      const mil_sec = this.props.selectedDate
        ? moment(this.props.selectedDate).diff(moment(this.props.selectedDate).startOf("day"))
        : 0;
      this.setState({
        selected_time: mil_sec,
      });
    }
  }

  getFormattedSelection = () => {
    return new Date(this.props.selectedDate);
  };

  monthYearChanged = date => {
    this.setState({
      month: date,
    });
  };

  render_caption = ({ date, localeUtils }) => {
    return <CaptionComp date={date} monthYearChanged={this.monthYearChanged} />;
  };

  timeChanged = time => {
    // "time" here is only the amount of milliseconds in a span of 24 hrs.
    // thus, after setting the state we pass the selected date if any or the current date to the newSelectedDate func
    // this intern adds the time constraint to selected date.
    this.setState(
      {
        selected_time: time,
      },
      () => {
        if (!this.props.selectedDate || this.props.selectedDate === 0) {
          this.newDaySelected(moment().valueOf());
        } else {
          this.newDaySelected(this.props.selectedDate);
        }
      }
    );
  };

  newDaySelected = date => {
    const date_time = moment(date)
      .startOf("day")
      .valueOf();
    const modified_date_time = date_time + this.state.selected_time;
    this.props.handleDayClick(new Date(modified_date_time));
  };

  render() {
    const wrapperClass = classNames("date-time-picker--wrapping-div", this.props.extraClass);
    return (
      <div className={wrapperClass}>
        {this.props.topComponent && this.props.topComponent}
        <CalendarDatePicker
          onDayClick={this.newDaySelected}
          selectedDays={new Date(this.props.selectedDate)}
          month={new Date(this.state.month)}
          captionElement={this.render_caption}
        />
        {this.props.clockEnabled && (
          <CalendarClock selected_time={this.state.selected_time} selectedTimeChanged={this.timeChanged} />
        )}
        {this.props.bottomComponent && this.props.bottomComponent}
      </div>
    );
  }
}

export default DateTimePicker;
